import AppearencesInMedia from './AppearencesInMedia';

export default AppearencesInMedia;
